import EmptyMyProductList from "./EmptyCustomerList";
import {Datagrid, EditButton, ImageField, List, TextField} from "react-admin";
import {Button} from "@material-ui/core";
import * as React from "react";

export const MyProductList = (props) => (
    <List {...props} perPage={25} empty={<EmptyMyProductList/>}>
        <Datagrid rowClick="edit">
            <TextField source="id" label="ID ColorCode"/>
            <ImageField source="colorcode.colorCodeImg" label="ColorCode"/>
            <Button
                onClick={() => {
                    alert('Your custom action');
                }}
            >
                <svg xmlns="http://www.w3.org/2000/svg" enableBackground="new 0 0 24 24" height="24"
                     viewBox="0 0 24 24" width="24">
                    <g>
                        <rect fill="none" height="24" width="24"/>
                    </g>
                    <g>
                        <path d="M5,20h14v-2H5V20z M19,9h-4V3H9v6H5l7,7L19,9z"/>
                    </g>
                </svg>
            </Button>
            <EditButton label="Modifica"/>
        </Datagrid>
    </List>
)